import { getEntities } from "./crudOperations";

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

/**
 * získá z API státy
 * @param setCountries funkce, do které se vloží výsledek
 */
export function loadCountries(setCountries: any): void {
  getEntities("country", setCountries, undefined, undefined, false);
}

/**
 * získá z API měny
 * @param setCurrencies funkce, do které se vloží výsledek
 */
export function loadCurrencies(setCurrencies: any): void {
  getEntities("currency", setCurrencies, undefined, undefined, false);
}

/**
 * získá z API předčíslí
 * @param setPreselections funkce, do které se vloží výsledek
 */
export function loadPreselections(setPreselections: any): void {
  getEntities("preselection", setPreselections, undefined, undefined, false);
}

/**
 * získá z API uživatelské role
 * @param setUserRoles funkce, do které se vloží výsledek
 */
export function loadUserRoles(setUserRoles: any): void {
  getEntities("user/role", setUserRoles, undefined, undefined, false);
}

/**
 * získá z API obaly
 * @param setWrappings funkce, do které se vloží výsledek
 */
export function loadWrappings(setWrappings: any, productId: number): void {
  getEntities("wrapping", setWrappings, undefined, { productId }, false);
}

/**
 * získá dostupné produkty klienta z API
 * @param setProducts funkce, do které se vloží výsledek
 * @param cleanData jestli ma dojit k promazani dat pomoci setEntities
 */
export function loadProducts(setProducts: any, cleanData = true): void {
  getEntities("product", setProducts, undefined, undefined, cleanData);
}

/**
 * získá dostupné UN třídy klienta z API
 * @param setUnClasses funkce, do které se vloží výsledek
 * @param cleanData jestli ma dojit k promazani dat pomoci setEntities
 */
export function loadUnClasses(setUnClasses: any, cleanData = true): void {
  getEntities("un-class", setUnClasses, undefined, undefined, cleanData);
}

/**
 * získá dostupné obalové třídy klienta z API
 * @param setPackagingGroups funkce, do které se vloží výsledek
 * @param cleanData jestli ma dojit k promazani dat pomoci setEntities
 */
export function loadPackagingGroups(
  setPackagingGroups: any,
  cleanData = true
): void {
  getEntities(
    "packaging-group",
    setPackagingGroups,
    undefined,
    undefined,
    cleanData
  );
}

/**
 * získá dostupné druhy obalů klienta z API
 * @param setPackagingTypes funkce, do které se vloží výsledek
 * @param cleanData jestli ma dojit k promazani dat pomoci setEntities
 */
export function loadPackagingTypes(
  setPackagingTypes: any,
  cleanData = true
): void {
  getEntities(
    "packaging-type",
    setPackagingTypes,
    undefined,
    undefined,
    cleanData
  );
}

/**
 * získá z API dostupné maximální ceny zásilky v různých měnách
 * @param setMaxPrices funkce, do které se vloží výsledek
 */
export function loadMaxConsignmentPrices(productId: number, setMaxPrices: any) {
  getEntities(
    "consignment/max-price",
    setMaxPrices,
    undefined,
    { productId },
    false
  );
}

/**
 * získá z API dostupné maximální hodnoty dobírky v různých měnách
 * @param setMaxAmounts funkce, do které se vloží výsledek
 */
export function loadMaxCodAmounts(productId: number, setMaxAmounts: any) {
  getEntities(
    "consignment/max-cod-amount",
    setMaxAmounts,
    undefined,
    { productId },
    false
  );
}

export function loadDocumentTypes(setDocumentTypes: any) {
  getEntities("document/type", setDocumentTypes, undefined, undefined, false);
}
